import { getClubLeadInfo, updateClubLead } from "./api"
import { leadMatchesDraft, leadPayload } from "./leadDraft"

// The gateway acknowledges queueing, not persistence. Read back the edited fields
// even after a correlated socket success; polling also covers lost socket events.
export function saveClubLead({
  previous, draft, socket, socketClientId, correlationId, verifyOnly = false,
  timeoutMs = 30000, intervalMs = 2000,
}) {
  const operationId = correlationId || Array.from(window.crypto.getRandomValues(new Uint32Array(4))).join("-")
  let finished = false
  let reading = false
  let pollTimer
  let deadline
  let resolve
  const promise = new Promise(done => { resolve = done })
  const finish = result => {
    if (finished) return
    finished = true
    clearTimeout(pollTimer)
    clearTimeout(deadline)
    socket?.off("clubs-response", onResponse)
    resolve(result)
  }
  const read = async () => {
    if (finished || reading) return
    clearTimeout(pollTimer)
    reading = true
    try {
      const { data } = await getClubLeadInfo(previous.id)
      if (data?.id === previous.id && new Date(data.updatedAt) > new Date(previous.updatedAt) && leadMatchesDraft(data, draft)) {
        finish({ status: "saved", lead: data })
      }
    } catch (error) {
      // A failed verification cannot prove that the queued mutation failed.
    } finally {
      reading = false
      if (!finished) pollTimer = setTimeout(read, intervalMs)
    }
  }
  const onResponse = response => {
    if (response?.correlationId !== operationId) return
    if (response.success === false) finish({ status: "error", message: "The lead could not be saved. Your changes are still here. Please review them and try again." })
    else if (response.success === true) read()
  }
  socket?.on("clubs-response", onResponse)
  deadline = setTimeout(() => finish({ status: "unknown" }), timeoutMs)
  const submit = async () => {
    if (!verifyOnly) {
      try {
        const response = await updateClubLead(previous.id, {
          ...leadPayload(draft), ...(socketClientId ? { socketClientId } : {}),
        }, operationId)
        if (response?.success === false) {
          finish({ status: "error", message: "The request was rejected. Your changes have been kept." })
          return
        }
      } catch (error) {
        // Network errors and 5xx may happen after queueing; do not offer a blind retry.
        if (error.response?.status >= 400 && error.response?.status < 500) {
          finish({ status: "error", message: "The request was rejected. Check your changes and access, then try again." })
          return
        }
      }
    }
    read()
  }
  submit()
  return { promise, correlationId: operationId, cancel: () => finish({ status: "cancelled" }) }
}
